<template>
  <div id="notifications">
    <page-title title="Notificaties" description="Verzonden meldingen naar gebruikers"></page-title>
    <router-link to="/new-notification" class="btn btn-success btn-lg mb-3">+ nieuwe melding</router-link>
    <div id="notifications-table" v-if="notifications.length">
      <table class="table table-hover">
        <thead class="thead-light">
          <tr>
            <th>Verzenddatum</th>
            <th>Titel</th>
            <th>Bericht</th>
            <th>Bereik (push)</th>
            <!--<th>read</th> -->
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in notifications" :key="item.id">
            <td>
              <DateFormat :date="item.dateCreated" day time></DateFormat>
            </td>
            <td>{{item.title}}</td>
            <td>{{item.message}}</td>
            <td>{{item.target}} ({{item.send}})</td>
            <!-- <td>12</td> -->
            <td>
              <Icon icon="trash" title="verwijder" v-on:clicked="deleteItem(index)" danger></Icon>
              <!-- <button class="btn btn-success btn-sm ml-2" @click="deleteItem(index)">kopie</button> -->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="!notifications | !notifications.length">
      <p>Klik op de groene button om een eerste melding te maken.</p>
    </div>
  </div>
</template>

<script>
const fb = require("@/firebaseConfig.js");
//var firestorage = fb.firestorage;

import { mapState } from "vuex";
import PageTitle from "@/components/PageTitle.vue";
import DateFormat from "@/components/DateFormat.vue";
import Icon from "@/components/icon.vue";

export default {
  name: "Notifications",
  components: {
    PageTitle,
    DateFormat,
    Icon
  },
  computed: {
    ...mapState(["currentUser", "userProfile"])
  },
  data() {
    return {
      notifications: [],
      cid: this.$cookies.get("company")
    };
  },
  methods: {
    deleteItem(index) {
      this.$confirm({
        message: "Weet je zeker dat je deze melding wilt verwijderen?",
        button: {
          no: "annuleren",
          yes: "verwijderen"
        },
        /**
         * Callback Function
         * @param {Boolean} confirm
         */
        callback: confirm => {
          if (confirm) {
            var id = this.notifications[index].id;
            fb.notificationsCollection
              .doc(id)
              .delete()
              .then(() => this.notifications.splice(index, 1))
              .catch(function(e) {
                alert("Kon niet verwijderd worden");
                // TODO toast message
                console.log(e.message);
              });
          }
        }
      });
    }
  },
  created() {
    console.log("notifications ophalen");
    fb.notificationsCollection
      .where("company", "==", this.$cookies.get("company"))
      .where("hidden", "==", false)
      .orderBy("date", "desc")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          console.log(doc.id);
          let d = doc.data();
          const data = {
            id: doc.id,
            created_by: d.created_by,
            dateCreated: d.date.toDate(), // new Date(d.date_created),
            type: d.type, // should allways be notifications because those are the only ones with hidden==false
            establishments: d.establishments,
            positions: d.positions,
            message: d.message,
            refid: d.refid, // itself so could be omitted
            title: d.title,
            send: d.send,
            target: d.target
          };
          this.notifications.push(data);
        });
      });
  }
};
</script>